import { Component, computed, effect, ElementRef, input, signal } from '@angular/core';
import { NgClass } from '@angular/common';

interface Step { label?: string; position: number  | string; }

@Component({
  selector: 'app-progress-bar',
  imports: [NgClass],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  steps = input<Step[]>([]);
  value = input<number>(0);
  min = input<number>(0);
  max = input<number>(100);
  labelPosition = input<'top' | 'bottom'>('top'); // верх або низ
  labelClass = input<string>('');
  showShadow = input<boolean>(false);

  public hostSize = signal<{ w: number; h: number }>({ w: 0, h: 0 });

  readonly padding = 5;
  readonly centerY = computed(() => this.hostSize().h / 2);

  readonly valueX = computed(() => {
    const { w } = this.hostSize();
    const range = this.max() - this.min() || 1;
    const full = w - this.padding * 2;
    const v = Math.max(this.min(), Math.min(this.value(), this.max()));
    return this.padding + ((v - this.min()) / range) * full;
  });

  readonly coords = computed(() => {
    const { w } = this.hostSize();
    const range = this.max() - this.min() || 1;
    const full = w - this.padding * 2;
    const v = this.value();

    return this.steps().map(step => {
      const x = this.padding + ((Number(step.position) - this.min()) / range) * full;
      const active = Number(step.position) <= v;
      return { ...step, x, active };
    });
  });

  constructor(private el: ElementRef<HTMLElement>) {
    const ro = new ResizeObserver(entries => {
      for (const e of entries) {
        this.hostSize.set({
          w: e.contentRect.width,
          h: 30,
        });
      }
    });
    ro.observe(this.el.nativeElement);

    // auto clean on Destroy
    effect(() => {
      if (this.el.nativeElement.isConnected === false) ro.disconnect();
    });
  }
}
